import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BranchGetApi } from '../Utils/Axios';

// Async thunk to fetch branches
export const fetchBranches = createAsyncThunk('branches/fetchBranches', async (_, { rejectWithValue }) => {
    try {
        const response = await BranchGetApi();
        return response.data.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch branches');
    }
});

const branchSlice = createSlice({
    name: 'branches',
    initialState: {
        branches: [],
        loading: false,
        error: null,
    },
    reducers: {
        removeBranchFromState: (state, action) => {
            state.branches = state.branches.filter(branch => branch.id !== action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranches.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBranches.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload;
            })
            .addCase(fetchBranches.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { removeBranchFromState } = branchSlice.actions;
export default branchSlice.reducer;
